import { BillingEventData } from "@/common/types/billing/event.type";
import { formatCurrency, formatDateTime } from "@/common/utils/formatters";
import { transformToNumber } from "@/common/utils/transformers";
import CompanyConsumptionDetails from "@/features/equipments/components/show/consumptionHistory/CompanyConsumptionDetails";
import CompanyRefundDetails from "@/features/equipments/components/show/consumptionHistory/CompanyRefundDetails";
import { eventableTypeTranslations } from "@/features/equipments/services/equipmentEventsTransformer";
import { ArrowBigRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { billingEventsFiscalDocumentsStatus } from "../constants/eventsFiscalDocumentsStatusOptions.constant";

export class BillingEventsFiscalDocumentsTransformer {
  static tableTransformer() {
    return (events: BillingEventData[]) => {
      return events.map((event) => {
        return {
          ...event,
          status: event.eventable?.fiscal_document_status ? billingEventsFiscalDocumentsStatus[event.eventable?.fiscal_document_status as keyof typeof billingEventsFiscalDocumentsStatus] : '',
          type: event.eventable_type ? eventableTypeTranslations[event.eventable_type] : '',
          details: eventableDetailsComponent[event.eventable_type] ? React.createElement(eventableDetailsComponent[event.eventable_type], { data: event.eventable }) : '',
          total_amount: event.total_amount ? formatCurrency(transformToNumber({ value: event.total_amount, invert: true })) : '',
          client_company_branch: event.eventable?.client_branch?.display_name,
          created_at: formatDateTime(new Date(event.created_at)),
          action: (
            <Link to={event.id}>
              <ArrowBigRight />
            </Link>
          ),
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (events: BillingEventData[]) => {
      return events.map((event) => ({
        route: `/events-with-fiscal-document-requirement/${event.id}`,
        items: [
          ['Transação', event.protocol_number],
          ['Tipo', event.eventable_type ? eventableTypeTranslations[event.eventable_type] : ''],
          ['Status', event.eventable?.fiscal_document_status ? billingEventsFiscalDocumentsStatus[event.eventable?.fiscal_document_status as keyof typeof billingEventsFiscalDocumentsStatus] : ''],
          ['Estabelecimento', event.eventable?.establishment_branch?.general_information?.fantasy_name],
        ]
      }));
    };
  }
}

export const eventableDetailsComponent: { [key: string]: React.ComponentType<any>; } = {
  'Client::Consumption': CompanyConsumptionDetails,
  'Billing::Refund': CompanyRefundDetails,
};
